import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatTableDataSource } from '@angular/material/table'

@Component({
  selector: 'app-device-alert-items-modal',
  templateUrl: './device-alert-items-modal.component.html',
  styleUrls: ['./device-alert-items-modal.component.scss']
})
export class DeviceAlertItemsModalComponent {

  displayedColumns = ['name', 'count']
  dataSource: MatTableDataSource<{ name: string; count: number }>

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { items: [string, number][] }
  ) {
    this.dataSource = new MatTableDataSource(
      data.items.map(i => ({ name: i[0], count: i[1] }))
    )
  }
}
